import styled from 'styled-components';

export const MapsWrapper = styled.a`
    &:before {
        display: none;
    }
`;

export const Icon = styled.img`
    width: 20px;
    @media (max-width: 1199px) {
        display: none;
    }
`;

export const IconResponsive = styled.img`
    width: 32px;
    @media (min-width: 1200px) {
        display: none;
    }
`;